export class ReferralInfo {

    referralName: string;

	registrationSourceId: number;

}
